module.exports = __webpack_public_path__ + "static/media/mobileScreenshot03.abcd0d8b.jpg";